import React from 'react'
import { Grid } from '@mui/material'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import PresentationCard from 'components/card/PresentationCard'
import { IMPORT, EXPORT, ALERTE, CALCUL, STATION_INTEGRATION, DATA_ADD_LAST_DATA, IMPORT_TYPE, OTHER } from 'traitements/constants/TraitementConstants'
import { Calculate, FileDownload, FileUpload, NoteAdd, NotificationsActive } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { push } from '@lagunovsky/redux-react-router'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'


const defaultSize = 60

const getDefaultParams = (stationType) => {
    switch (stationType) {
        case IMPORT_TYPE.HYDRO_PORTAIL:
            return {
                filters: [],
                dataTypes: [STATION_INTEGRATION, DATA_ADD_LAST_DATA, 'withPred', 'heightIntegration', 'debitIntegration', 'withEvents', 'withThresholds'],
            }
        default:
            return { filters: {}, dataTypes: [] }
    }
}

const updateParams = (stationType, setFilters, setJobDataTypes) => {
    const params = getDefaultParams(stationType)
    setFilters(params.filters)
    setJobDataTypes(params.dataTypes)
}

const AddTreatementStepActionTreatment = ({
    changeStation,
    nextStep,
    setFilters,
    setJobDataTypes,
    setactiontreatement,
    setChoices,
    setTypeJob,
}) => {
    const dispatch = useDispatch()
    const handleSimpleAdd = () => {
        dispatch(push('/import/0'))
    }
    return (
        <Grid container justifyContent='center' alignItems='center' spacing={3}>
            <Grid size={5} >
                <PresentationCard
                    iconComponent={<FileDownload sx={{ fontSize: defaultSize }} />}
                    title= {IMPORT}
                    onClick={() => {
                        setTypeJob('import')
                        setChoices(prev => ({
                            ...prev,
                            TRAITEMENT: `(${IMPORT})`,
                        }))
                        setactiontreatement(IMPORT)
                        nextStep()
                    }}
                    description={i18n.hydroImport}
                />
            </Grid>
            <Grid size={5}>
                <PresentationCard
                    iconComponent={<FileUpload sx={{ fontSize: defaultSize }} />}
                    title= {EXPORT}
                    onClick={() => {
                        setTypeJob('export')
                        setChoices(prev => ({
                            ...prev,
                            TRAITEMENT: `(${EXPORT})`,
                        }))
                        setactiontreatement(EXPORT)
                        nextStep()
                    }}
                    description={`${i18n.hydroExport} / ${i18n.inDeveloppmentFunctionnality}`}
                />
            </Grid>
            <Grid size={5}>
                <PresentationCard
                    iconComponent={<NotificationsActive sx={{ fontSize: defaultSize }} />}
                    title= {ALERTE}
                    onClick={() => {
                        setTypeJob('alert')
                        setChoices(prev => ({
                            ...prev,
                            TRAITEMENT: `(${ALERTE})`,
                        }))
                        setactiontreatement(ALERTE)
                        nextStep()
                    }}
                    description={`${i18n.definitionOfAlertRulesOnData} / ${i18n.inDeveloppmentFunctionnality}`}
                />
            </Grid>
            <Grid size={5}>
                <PresentationCard
                    iconComponent={<Calculate sx={{ fontSize: defaultSize }} />}
                    title= {CALCUL}
                    onClick={() => {
                        setTypeJob('calcul')
                        setChoices(prev => ({
                            ...prev,
                            TRAITEMENT: `(${CALCUL})`,
                        }))
                        setactiontreatement(CALCUL)
                        nextStep()
                    }}
                    description={`${i18n.processingOfSpecificCalculations} / ${i18n.inDeveloppmentFunctionnality}`}
                />
            </Grid>
            <Grid size={5}>
                <PresentationCard
                    iconComponent={<MoreHorizIcon sx={{ fontSize: defaultSize }} />}
                    title= {i18n.others}
                    onClick={() => {
                        setTypeJob('notDefined')
                        setChoices(prev => ({
                            ...prev,
                            TRAITEMENT: `(${i18n.others})`,
                        }))
                        setactiontreatement(OTHER)
                        nextStep()
                    }}
                />
            </Grid>
            <Grid size={5}>
                <PresentationCard
                    iconComponent={<NoteAdd sx={{ fontSize: defaultSize }} />}
                    title={i18n.defineAProcessManually}
                    onClick={() => {
                        setChoices(prev => ({
                            ...prev,
                            TRAITEMENT: i18n.defineAProcessManually,
                        }))
                        changeStation({ stationType: IMPORT_TYPE.EMPTY })
                        updateParams(IMPORT_TYPE.EMPTY, setFilters, setJobDataTypes)
                        handleSimpleAdd()
                    }}
                    data-cy='add_other_treatment_card'
                />
            </Grid>
        </Grid>
    )
}

AddTreatementStepActionTreatment.propTypes = {
    nextStep: PropTypes.func,
    changeStation: PropTypes.func,
    setFilters: PropTypes.func,
    setJobDataTypes: PropTypes.func,
    setactiontreatement: PropTypes.func,
    setChoices: PropTypes.func,
    setTypeJob: PropTypes.func,
}

export default AddTreatementStepActionTreatment